export const LoginLogoutPaths = {
  login: {
    path: '/fv7ui-secured/',
  },
  public: {
    path: '/fv7ui-pubauth/'
  }
} as const;
